const applicationName = 'tyc-web-search';
const hostname = '0.0.0.0';
const port = parseInt(process.env.PORT, 10) || 7004;

module.exports = {
  applicationName,
  hostname,
  port,
};
